<template>
  <div>
    <LoadingPlugin
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    />

    <add-origin
      v-if="showModal"
      :show="showModal"
      :onCancel="closeModal"
      :isAddShipment="true"
      @newOrigin="newOrigin"
      :newShipmentOrigin="newShipmentOrigin"
    />

    <add-destination
      v-if="showDestination"
      :show="showDestination"
      :onCancel="closeDestination"
      :isAddShipment="true"
      @newDestination="newDestination"
      :newShipmentDestination="newShipmentDestination"
    />

    <form ref="originDestinationForm">
      <div class="row">
        <div class="col-12 col-sm-6">
          <div class="form-group">
            <div class="d-flex justify-content-between align-items-center mb-1">
              <label for="reference">Origin</label>
              <button @click="showModal = true" class="custom-button">
                <icon-circle-add class="cursor-pointer" />
                Add Origin
              </button>
            </div>
            <div class="input-group">
              <select
                class="form-control"
                style="height: 50px"
                name="origin"
                v-model="origin"
                required
              >
                <option
                  :value="newShipmentOrigin"
                  v-if="newShipmentOrigin && newShipmentOrigin.address"
                  >{{ newShipmentOrigin.name }}</option
                >
                <option
                  v-for="origin in origins"
                  :key="origin.id"
                  :value="origin"
                  >{{ origin.name }}</option
                >
              </select>
            </div>
          </div>

          <div class="form-group mb-0">
            <div class="d-flex justify-content-between align-items-center mb-1">
              <label for="reference">Destination</label>
              <span @click="showDestination = true" class="cursor-pointer">
                <icon-circle-add class="cursor-pointer" /> Add Destination
              </span>
            </div>
            <div class="input-group">
              <select
                class="form-control"
                style="height: 50px"
                name="destination"
                v-model="destination"
                required
              >
                <option
                  :value="newShipmentDestination"
                  v-if="
                    newShipmentDestination && newShipmentDestination.address
                  "
                  >{{ newShipmentDestination.name }}</option
                >
                <option
                  :value="destination"
                  v-for="destination in destinations"
                  :key="destination.id"
                  >{{ destination.name }}</option
                >
              </select>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6">
          <map-direction
            :start="originLatLng"
            :end="destinationLatLng"
            @isLoading="handleLoading"
          />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import IconCircleAdd from "../../../components/Iconsvg/IconCircleAdd.vue";
import MapDirection from "./MapDirection.vue";
import AddOrigin from "../../Modals/AddOrigin.vue";
import AddDestination from "../../Modals/AddDestination.vue";
import LoadingPlugin from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  components: {
    IconCircleAdd,
    MapDirection,
    AddOrigin,
    AddDestination,
    LoadingPlugin,
  },
  name: "OriginDestinationStep",
  props: {
    originProp: {
      type: Object,
      default: () => ({}),
    },
    destinationProp: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      origin: {},
      destination: {},
      showModal: false,
      showDestination: false,
      newShipmentOrigin: {},
      newShipmentDestination: {},
      isLoading: false,
      fullPage: true,
    };
  },
  computed: {
    ...mapGetters(["destinations", "origins"]),
    originLatLng() {
      if (this.origin.address) {
        const { lat, lng } = this.origin.address;
        return { lat, lng };
      } else return null;
    },
    destinationLatLng() {
      if (this.destination.address) {
        const { lat, lng } = this.destination.address;
        return { lat, lng };
      } else return null;
    },
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },
    closeDestination() {
      this.showDestination = false;
    },
    validateForm() {
      const form = this.$refs.originDestinationForm;
      if (!form.checkValidity()) {
        form.reportValidity();
        return false;
      }
      return true;
    },
    getFormData() {
      return {
        origin: this.origin,
        destination: this.destination,
      };
    },
    newOrigin(origin) {
      this.origin = origin;
      this.newShipmentOrigin = origin;
      this.showModal = false;
    },
    newDestination(destination) {
      this.destination = destination;
      this.showDestination = false;
      this.newShipmentDestination = destination;
    },
    handleLoading(isLoading) {
      this.isLoading = isLoading;
    },
  },
  watch: {
    originProp: {
      handler(newValues) {
        if (newValues.address) {
          this.origin = this.originProp;
          if (!this.originProp.id) {
            this.newShipmentOrigin = this.originProp;
          }
        }
      },
      deep: true,
      immediate: true,
    },
    destinationProp: {
      handler(newValues) {
        if (newValues.address) {
          this.destination = this.destinationProp;
          if (!this.destinationProp.id) {
            this.newShipmentDestination = this.destinationProp;
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
button.custom-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #213e7a;
}

button.custom-button:focus {
  outline: none; /* Remove focus outline if not desired */
}
</style>
